module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qnerv13-3706df2b494d389258439b5dd4efb43b.jpg";